import { render } from "./LanguageView.vue?vue&type=template&id=d4d907f6"
import script from "./LanguageView.vue?vue&type=script&lang=js"
export * from "./LanguageView.vue?vue&type=script&lang=js"

import exportComponent from "/opt/builds/JFRxnycJ/0/firma/firmenwebseite/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__